// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceConfigRenewalDto } from './IServiceConfigRenewalDto';
import {
    IServiceConfigRenewalDtoFromJSON,
    IServiceConfigRenewalDtoFromJSONTyped,
    IServiceConfigRenewalDtoToJSON,
    IServiceConfigRenewalDtoToJSONTyped,
} from './IServiceConfigRenewalDto';

/**
 * 
 * @export
 * @interface IProcessingTierRenewalDto
 */
export interface IProcessingTierRenewalDto {
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierRenewalDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierRenewalDto
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierRenewalDto
     */
    next_tier_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierRenewalDto
     */
    payout_rule_type?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IProcessingTierRenewalDto
     */
    card_purse_lock_plan_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IProcessingTierRenewalDto
     */
    card_purse_lock_plan_names?: Array<string>;
    /**
     * 
     * @type {Array<IServiceConfigRenewalDto>}
     * @memberof IProcessingTierRenewalDto
     */
    service_configs?: Array<IServiceConfigRenewalDto>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IProcessingTierRenewalDto
     */
    tier_trigger_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierRenewalDto
     */
    payout_definition_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessingTierRenewalDto
     */
    is_send_trigger_notification?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierRenewalDto
     */
    plan_id?: number;
}

/**
 * Check if a given object implements the IProcessingTierRenewalDto interface.
 */
export function instanceOfIProcessingTierRenewalDto(value: object): value is IProcessingTierRenewalDto {
    return true;
}

export function IProcessingTierRenewalDtoFromJSON(json: any): IProcessingTierRenewalDto {
    return IProcessingTierRenewalDtoFromJSONTyped(json, false);
}

export function IProcessingTierRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessingTierRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'next_tier_name': json['next_tier_name'] == null ? undefined : json['next_tier_name'],
        'payout_rule_type': json['payout_rule_type'] == null ? undefined : json['payout_rule_type'],
        'card_purse_lock_plan_ids': json['card_purse_lock_plan_ids'] == null ? undefined : json['card_purse_lock_plan_ids'],
        'card_purse_lock_plan_names': json['card_purse_lock_plan_names'] == null ? undefined : json['card_purse_lock_plan_names'],
        'service_configs': json['service_configs'] == null ? undefined : ((json['service_configs'] as Array<any>).map(IServiceConfigRenewalDtoFromJSON)),
        'tier_trigger_ids': json['tier_trigger_ids'] == null ? undefined : new Set(json['tier_trigger_ids']),
        'payout_definition_id': json['payout_definition_id'] == null ? undefined : json['payout_definition_id'],
        'is_send_trigger_notification': json['is_send_trigger_notification'] == null ? undefined : json['is_send_trigger_notification'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
    };
}

export function IProcessingTierRenewalDtoToJSON(json: any): IProcessingTierRenewalDto {
    return IProcessingTierRenewalDtoToJSONTyped(json, false);
}

export function IProcessingTierRenewalDtoToJSONTyped(value?: IProcessingTierRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'display_name': value['display_name'],
        'next_tier_name': value['next_tier_name'],
        'payout_rule_type': value['payout_rule_type'],
        'card_purse_lock_plan_ids': value['card_purse_lock_plan_ids'],
        'card_purse_lock_plan_names': value['card_purse_lock_plan_names'],
        'service_configs': value['service_configs'] == null ? undefined : ((value['service_configs'] as Array<any>).map(IServiceConfigRenewalDtoToJSON)),
        'tier_trigger_ids': value['tier_trigger_ids'] == null ? undefined : Array.from(value['tier_trigger_ids'] as Set<any>),
        'payout_definition_id': value['payout_definition_id'],
        'is_send_trigger_notification': value['is_send_trigger_notification'],
        'plan_id': value['plan_id'],
    };
}

